export const FETCH_CURRENT_PAGE = "fetchCurrentPageData";
export const FETCH_PREVIEW_PAGE = "fetchPreviewPageData";
export const FETCH_MAIN_MENU = "fetchMainMenu";
export const FETCH_PROJECT_SETTINGS = "fetchProjectSettings";
export const FETCH_PROJECT_DATA = "fetchprojectData";
export const FETCH_SOCIAL = "fetchSociallinkData";
// login
export const GET_PUBLIC_IMAGES: string = "getPublicImages";
export const LOGIN: string = "login";
export const LOGOUT: string = "logout";
export const GET_PROFILE_DATA: string = "getProfileData";

export const FETCH_GLOBAL = "fetchgloballinkItemData";
